export const mutations = {
    setBandeiraCartao(state, data) {
        state.bandeiraCartao = data
    },
    setBandeirasCartao(state, data) {
        state.bandeirasCartao = data
    },
    addBandeiraCartao(state, data){
        state.bandeirasCartao.push(data)
    },
    removeBandeiraCartao(state, data){
        let index = state.bandeirasCartao.map(x => x.id).indexOf(data.id);
        state.bandeirasCartao.splice(index, 1)
    },
    setModalCadastrarBandeiraCartao(state, status) {
        state.modalCadastrarBandeiraCartao = status
    },
    setModalExcluirBandeiraCartao(state, status) {
        state.modalExcluirBandeiraCartao = status
    },
}

export default {}